import React, { Component } from "react";
import { connect } from "react-redux";
// import { TweenMax } from "gsap";
import { gameMusic, fadeMusic, voiceStatic,playSndFx } from "../../actions/actionCreators.js";
import { createDarkPattern } from '../../actions/darkPatterns.js';
import { frameRate } from "../scenemanager/manifest.js";
import { maxSceneWidth } from "../utils/helpers.js";

import { createClickerPattern } from "../darkpatterns/createPatterns.js";

import PatternManager from "../darkpatterns/PatternManager.js";
import Hud from "../hud/Hud";
import RoundStartText from "../RoundStartText";
import RoundEndText from "../RoundEndText";
import timer from "../../lib/timer.js";

const seq = p => {
	let i = 0;
	const c = p.length - 1;
	const ended = () => i > c;
	return {
		step : () => { i = ended() ? 0 : i + 1; },
		current : () => p[ i ]
	}
};

const mapDispatchToProps = dispatch => {
	return {
		fadeMusic: () => dispatch(fadeMusic()),
		gameMusic: track => dispatch(gameMusic( track )),
		voiceStatic: track => dispatch(voiceStatic(track)),
		createPattern : config => dispatch(createDarkPattern( config )),
		playSndFx : fx => dispatch(playSndFx(fx))
	};
};

class ThreeDView extends Component {
	constructor(props) {
		super(props);
		
		const adseq = seq(props.seq);
		const ticksPerSecond = ( props.bpm / 60 ) * frameRate;

		this.state = {
			gameStart: false,
			gameEnd: false,
			countdown: props.duration
		};
		this.timer = timer( ticksPerSecond, "GAME_TIMER_id_" );
		this.updateCycle = this.timer.add( delta => {
			if(adseq.current() && this.state.countdown >= ( props.speed / 2 ) ){
				props.createPattern( createClickerPattern( props.speed ) );
			}
			adseq.step();
			this.setState({ countdown: this.state.countdown - ( delta / 1000 ) });
		} );
		this.startGame = () => {
			this.timer.start()
			this.setState({ gameStart: true });
		}
	}
	componentDidMount() {
		// if level 3, don't play music, it should already be playing...
		if (this.props.round !== 3) this.props.gameMusic( this.props.music );
		this.props.voiceStatic( this.props.intro );
		// this.startGame();
	}
	componentWillUpdate() {
		if (this.state.countdown <= 0 && !this.state.gameEnd) {
			this.props.voiceStatic( this.props.outro );
			this.timer.stop();
			this.timer.remove( this.updateCycle );
			this.setState( { gameEnd: true } );
		}
	}

	componentWillUnmount() {
		this.props.fadeMusic();
	}
	
	render() {
		return (
			<div className="bodyWrapper" style={maxSceneWidth()}>
				<div className="body rc">
					<RoundStartText
						duration={this.props.introDelay}
						introPrompt={this.props.introPrompt}
						introBubble={this.props.introBubble}
						avatar={this.props.avatar}
						round={this.props.round}
						playSndFx={this.props.playSndFx}
						callback={this.startGame}/>
					<Hud countdown={this.state.countdown} hideScore={false} />
					{ this.state.gameStart && <PatternManager /> }
					{ this.state.gameEnd && <RoundEndText
						duration={this.props.outroDelay }
						text={this.props.outroBubble}
						avatar={this.props.avatar}
						round={this.props.round}
						callback={this.props.next}/> }
					<this.props.environment />
				</div>
			</div>
		);
	}
}

const ThreeD = connect(()=>({}), mapDispatchToProps)(ThreeDView);
export default ThreeD;



// WEBPACK FOOTER //
// ./src/components/scenes/ThreeD.js